import { PriceDisplay } from '../PriceDisplay';
import {
  Content,
  MetaItem,
  MetaList,
  PriceColumn,
  RemoveButton,
  RemoveRow,
  SubPriceRow,
  TextColumn,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  Title,
  TopRow,
  Wrapper,
} from './BasketCard.styles';
import type { BasketCardProps } from './BasketCard.types';

export function BasketCard({
  title,
  imageUrl,
  imageAlt,
  meta,
  extras,
  price,
  subPrice,
  subPriceSuffix,
  locale,
  noImageLabel = 'No image',
  onRemove,
  removeLabel = 'Remove',
}: BasketCardProps) {
  const detailLines = [...(meta ?? []), ...(extras ?? [])];

  return (
    <Wrapper data-testid="basket-card">
      <TopRow>
        <Thumbnail>
          {imageUrl ? (
            <ThumbnailImage src={imageUrl} alt={imageAlt ?? title} />
          ) : (
            <ThumbnailPlaceholder aria-hidden="true">{noImageLabel}</ThumbnailPlaceholder>
          )}
        </Thumbnail>

        <Content>
          <TextColumn>
            <Title>{title}</Title>
            {detailLines.length > 0 && (
              <MetaList>
                {detailLines.map((line, index) => (
                  <MetaItem key={`${line}-${index}`}>{line}</MetaItem>
                ))}
              </MetaList>
            )}
          </TextColumn>

          <PriceColumn>
            <PriceDisplay
              amount={price.amount}
              currencyCode={price.currencyCode}
              locale={locale}
              size="base"
              weight="medium"
            />
            {subPrice && (
              <SubPriceRow>
                <PriceDisplay
                  amount={subPrice.amount}
                  currencyCode={subPrice.currencyCode}
                  locale={locale}
                  size="small"
                  weight="normal"
                />
                {subPriceSuffix ? ` ${subPriceSuffix}` : ''}
              </SubPriceRow>
            )}
          </PriceColumn>
        </Content>
      </TopRow>

      {onRemove && (
        <RemoveRow>
          <RemoveButton type="button" onClick={onRemove}>
            {removeLabel}
          </RemoveButton>
        </RemoveRow>
      )}
    </Wrapper>
  );
}
